<template>
  <div class="footer">
    <div class="footer-in">
      <div class="footer-fl" :class="$t('language.name') != 'En' ? 'w2' : 'w1'">
        <!-- <img src="../assets/img/footerlogo.png" alt="saxo" class="logo fl"> -->
        <img
          :src="$i18n.locale === 'en' ? require('../assets/img/logo-vertical-white-en.png') : require('../assets/img/logo-vertical-white.png')"
          alt="geely" class="logo fl">
        <div class="text fl">
          <ul class="fl fr-inr">
            <li class="li" @click="checkNav('/about')">{{ $t("footer.aboutUs") }}</li>
            <li @click="checkNav('/contact')">{{ $t("footer.contactUs") }}</li>
            <li><a v-bind:href="joinUsSocialLink" target="_blank">{{ $t("nav.tab3_1") }}</a></li>
            <li><a v-bind:href="joinUsCampusLink" target="_blank">{{ $t("nav.tab3_2") }}</a></li>
          </ul>
          <br />
          <p class="p2">
            <span class="s1 fl">{{ $t("footer.name") }}</span>
            <span class="s2 fl">{{ $t("footer.No1") }}</span>
            <a href="https://beian.miit.gov.cn/" target="view_window" class="a fl">{{ $t("footer.No2") }}</a>
            <!-- <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50019002502329"
              class="fl ml20" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
              <img src="../assets/img/batb.png" style="float:left;" />
              <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#f8f8f8;">渝公网安备
                50019002502329号</p>
            </a> -->
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from '../assets/js/bus'
export default {
  name: 'Footer',
  components: {
  },
  methods: {
    checkNav(url) {
      if (this.$route.path != url) {
        Bus.$emit("nav", url);
        this.$router.push(url)
        document.body.scrollTop = 0
        // firefox
        document.documentElement.scrollTop = 0
        // safari
        window.pageYOffset = 0
      }
    }
  },
  data() {
    return {
      joinUsSocialLink: process.env.VUE_APP_MOKA_SOCIAL_LINK || '/join',
      joinUsCampusLink: process.env.VUE_APP_MOKA_CAMPUS_LINK || '/join'
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  width: 100%;
  height: 200px;
  background: #243F72;

  .footer-in {
    width: 1260px;
    height: 200px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;

    .logo {
      height: 90px;
      // width: 165px;
    }

    .footer-fl {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      overflow: hidden;



      .text {
        margin-top: 15px;
        margin-left: 60px;

        p {
          color: #F8F8F8;
          float: left;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 20px;
        }

        .p2 {
          margin-top: 20px;

          span {
            display: inline-block;
            line-height: 20px;
          }

          .s2 {
            margin-left: 20px;
          }

          .a {
            display: inline-block;
            color: #f8f8f8;
            margin-left: 20px;
            line-height: 20px;
          }

          .ml20 {
            margin-left: 20px;
          }
        }
      }

      .fr-inr {
        // max-width: 560px;
        float: left;
        position: relative;

        li {
          color: #F8F8F8;
          line-height: 20px;
          font-weight: 500;
          font-size: 14px;
          cursor: pointer;
          float: left;
          padding: 0 40px;
          position: relative;
        }

        li::before {
          position: absolute;
          width: 1px;
          height: 20px;
          background: #fff;
          content: "";
          top: 0;
          right: 0;
          opacity: 0.3;
        }

        li:last-child::before {
          width: 0;
        }

        .li {
          padding-left: 0;
        }

        a {
          color: #F8F8F8;
          text-decoration: none;
        }
      }
    }

    .w1 {
      width: 800px;
    }

    .w2 {
      width: 985px;
    }

    .footer-fr {
      width: 600px;
      padding-top: 90px;

      .fr-inl {
        // width: 150px;
        margin-right: 50px;

        img {
          width: 24px;
          height: 24px;
        }

        span {
          color: #F8F8F8;
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          margin-left: 15px;
        }

        p {
          font-size: 16px;
          color: #9FA4A8;
          margin-top: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footer.vue